// packages/components/src/tool-management/ToolFilterBar.tsx

import React from 'react';
import { Card, TextField, SelectField } from '@dopomogai/ui';
import { Search, Filter, ListFilter } from 'lucide-react'; // Added ListFilter for a better title icon

export interface ToolFilters {
  searchQuery: string;
  status: 'all' | 'enabled' | 'disabled';
  type: 'all' | 'python' | 'openapi_spec' | string;
}

interface ToolFilterBarProps {
  filters: ToolFilters;
  onFilterChange: (field: keyof ToolFilters, value: string) => void;
  statusOptions?: { value: string; label: string }[];
  typeOptions?: { value: string; label: string }[];
}

// Default options can be overridden by props
const DEFAULT_STATUS_OPTIONS = [
  { value: 'all', label: 'All Statuses' },
  { value: 'enabled', label: 'Enabled' },
  { value: 'disabled', label: 'Disabled' },
];

const DEFAULT_TYPE_OPTIONS = [
  { value: 'all', label: 'All Types' },
  { value: 'python', label: 'Python' },
  { value: 'openapi_spec', label: 'OpenAPI Spec' },
];

export const ToolFilterBar: React.FC<ToolFilterBarProps> = ({
  filters,
  onFilterChange,
  statusOptions = DEFAULT_STATUS_OPTIONS,
  typeOptions = DEFAULT_TYPE_OPTIONS,
}) => {
  return (
    // NEW: The entire component is now a self-contained, titled Card.
    <Card
      title="Search & Filter Tools"
      icon={<ListFilter size={18} />}
      noPadding={false}
      className="mb-6"
    >
      {/* NEW: Using a responsive grid for a clean, adaptive layout. */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <TextField
          label="Search Tools"
          placeholder="Search by name or description..."
          leadingIcon={<Search size={18} className="text-slate-400" />}
          value={filters.searchQuery}
          onChange={(e) => onFilterChange('searchQuery', e.target.value)}
        />
        <SelectField
          label="Filter by Status"
          name="statusFilter"
          value={filters.status}
          onChange={(value) => onFilterChange('status', String(value))}
          options={statusOptions}
          leadingIcon={<Filter size={18} className="text-slate-400" />}
        />
        <SelectField
          label="Filter by Type"
          name="typeFilter"
          value={filters.type}
          onChange={(value) => onFilterChange('type', String(value))}
          options={typeOptions}
          leadingIcon={<Filter size={18} className="text-slate-400" />}
        />
      </div>
    </Card>
  );
};